
import React from 'react'
import { TikTok } from "react-tiktok";



const TikTokCard = ({item}) => {
  const coloum_value = JSON.parse(item?.coloum_value);

  return (
    <div className='w-full max-w-[325px] rounded-lg overflow-hidden'>
    <TikTok url={coloum_value?.coloum_value} />
  
  </div>
  )
}

export default TikTokCard